<div>
  <div class="container card pb-5">
    <div class="not-found">
      <div class="not-found__404">Oops! Error 404</div>

      <div class="not-found__content">
        <h1 class="not-found__title">Pagina No Encontrada</h1>

        <p class="not-found__text">
          Parece que no podemos encontrar la página que estás buscando.
        </p>

        <p class="not-found__text">
          Vaya a la página de inicio para empezar de nuevo, si el problema
          persiste comuniquese por el formulario de contacto
        </p>

        <a class="btn btn-secondary btn-sm" [routerLink]="['/', 'inicio']"
          >Ir a la página principal</a
        >
      </div>
    </div>
  </div>
</div>
